import React from 'react';
import PropTypes from 'prop-types';
import Gravatar from 'react-gravatar';
import CommunityIcon from './community-icon.svg';
import styles from './styles.module.styl';

const CompanyIcon = () => (
  <img
    className={styles.auth0Logo}
    src="https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.svg"
    alt=""
  />
);

const Author = ({ email, name, community }) => {
  if (!name && community) {
    return (
      <div className={styles.anonymousCommunityAuthor}>
        <CommunityIcon className={styles.communityImage} />
        <span className={styles.communityText}>Community maintained</span>
      </div>
    );
  }

  return (
    <div className={styles.author}>
      <Gravatar email={email} default="mm" className={styles.avatar} />
      <div>
        <h5 className={styles.authorName}>By {name}</h5>
        <div className={styles.authorType}>
          <div className={styles.authorTypeImg}>
            {community ? <CommunityIcon /> : <CompanyIcon />}
          </div>
          <span className={styles.authorTypeText}>
            {community ? 'Community maintained' : 'Auth0'}
          </span>
        </div>
      </div>
    </div>
  );
};

Author.defaultProps = {
  community: false
};

Author.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  community: PropTypes.bool.isRequired
};

export default Author;
